import { z } from 'zod';
import { OfferStatusSchema } from './enums.schema.js';
export const ShiftOfferResponseSchema = z.object({
    id: z.string().uuid(),
    shiftRequestId: z.string().uuid(),
    caregiverId: z.string().uuid(),
    tier: z.number().int().min(1),
    targetedByOperator: z.boolean(),
    targetedByUserId: z.string().uuid().nullable(),
    targetReason: z.string().nullable(),
    offeredAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
    status: OfferStatusSchema,
    respondedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ShiftOfferListResponseSchema = z.object({
    items: z.array(ShiftOfferResponseSchema),
});
export const DeclineShiftOfferRequestSchema = z.object({
    reason: z.string().max(500).optional(),
});
//# sourceMappingURL=shift-offer.schema.js.map